// removed by extract-text-webpack-plugin
module.exports = {"root":"_2ftn2"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/styles/svg/ChevronLeft.scss
 ** module id = 443
 ** module chunks = 0
 **/